import classNames from 'classnames';
import React from 'react';
import PostArchivedBar from './PostArchivedBar';
import PostDraftBar from './PostDraftBar';
import PostLayout from './PostLayout';
import * as styles from './PostStateBar.module.scss';
import PostTemplateBar from './PostTemplateBar';
import { gql } from '../graphql/generated/gql';
import type { DocumentType } from '../graphql/generated/gql';
import { PostType } from '../graphql/generated/graphql';
import addTestId from '../utils/addTestId';
import { usePostLayoutSize } from '../utils/responsive/PostLayoutSizeProvider';

const BarComponents = {
  draft: PostDraftBar,
  archived: PostArchivedBar,
  template: PostTemplateBar,
};

const POST_FRAGMENT = gql(`
  fragment PostStateBar_post on Post {
    id
    archivedAt
    publishedAt
    type
    ...PostDraftBar_post
    ...PostArchivedBar_post
    ...PostTemplateBar_post    
  }  
`);

export interface PostStateBarComponentProps {
  compact: boolean;
}

interface PostStateBarProps {
  post: DocumentType<typeof POST_FRAGMENT>;
}

const PostStateBar = ({ post }: PostStateBarProps) => {
  const postLayoutSize = usePostLayoutSize();
  const isCompact = ['tablet', 'mobile'].includes(postLayoutSize);

  let variant: keyof typeof BarComponents | null = null;

  if (post) {
    if (post.archivedAt) {
      variant = 'archived';
    } else if (!post.publishedAt) {
      variant = 'draft';
    } else if (post.type === PostType.Template) {
      variant = 'template';
    }
  }

  const BarComponent = variant && BarComponents[variant];

  return post && variant && BarComponent ? (
    <PostLayout.StateBar
      data-no-print
      {...addTestId('postStateBar')}
      className={classNames(styles.container, styles[variant])}
    >
      <BarComponent post={post} compact={isCompact} />
    </PostLayout.StateBar>
  ) : null;
};

export default PostStateBar;
